module.exports = __webpack_public_path__ + "img/stock5.cdeff595.png";